export const MenuItems = [
  {
    title: "HOME",
    url: "#",
    cName: "navlinks"
  },
  {
    title: "GUIDELINES",
    url: "#GUIDLINES",
    cName: "navlinks"
  },
  {
    title: "TIMELINE",
    url: "#TIMELINE",
    cName: "navlinks"
  },
  {
    title: "PRIZES",
    url: "#PRIZES",
    cName: "navlinks"
  },
  {
    title: "OUR TEAM",
    url: "#OUR-TEAM",
    cName: "navlinks"
  },
  // {
  //   title: "PARTNERS",
  //   url: "#PARTNERS",
  //   cName: "navlinks"
  // },
  {
    title: "CONTACT",
    url: "#CONTACT",
    cName: "navlinks"
  },
];
